import { useState } from "react";
import { bool, string, object } from "prop-types";
import { observer } from "mobx-react";
import { lastResourceNameUsage } from "@utils";
import {
  useEstimateStructure,
  useEstimateEditorStore,
  TeamMemberSelectDialog,
} from "@tools";
import { useEditorWebsocket } from "@hooks";

export const WorkTypeResourceSelect = observer(({
  resource,
  navigationKey,
}) => {
  const structure = useEstimateStructure();
  const editorStore = useEstimateEditorStore();
  const socket = useEditorWebsocket()

  const { id, name, autoFocus, workTypeId } = resource;
  const { importRoleCostRates, importRoleSalesRates } = editorStore;

  const [ newlyCreatedRole ] = useState(autoFocus);

  const updateRole = (newRole) => {
    if(!newlyCreatedRole)
      structure.historyManager.startGroup();
    
    const path = resource.treePath.join("/");
    const timelinePath = "t" + path;
    const oldName = resource.name;
    const { id: systemId, roleName, salesRate, costRate } = newRole;
    
    const lastNameUsage = lastResourceNameUsage(
      resource.parent?.resources,
      roleName
    );
    
    const newName = lastNameUsage >= 0
      ? `${roleName} ${lastNameUsage + 1}`
      : roleName;

    if(salesRate && importRoleSalesRates)
      resource.setRate(salesRate);
    if(costRate && importRoleCostRates)
      resource.setCompanyUnitCost(costRate);
    
    resource.changeName(newName, systemId);
    
    if(newlyCreatedRole)
      structure.addSectionsResource(workTypeId, id);
    else {
      socket?.requestCommentPathElementRename(path, newName);
      socket?.requestCommentPathElementRename(timelinePath, newName);
      structure.historyManager.addCommentNamePatch(path, oldName, newName);
      structure.historyManager.addCommentNamePatch(timelinePath, oldName, newName);
    }
    structure.historyManager.stopGroup();
  };

  return (
    <TeamMemberSelectDialog
      workTypeId={workTypeId}
      defaultValue={name}
      updateRole={updateRole}
      autoFocus={autoFocus}
      removeAutofocus={resource.removeAutofocus}
      selfRemoveTeamMember={resource.removeSelf}
      navigationKey={navigationKey}
    />
  );
});

WorkTypeResourceSelect.propTypes = {
  resource: object.isRequired,
  displayTeamMembers: bool,
  noMinWidth: bool,
  navigationKey: string.isRequired,
};
